import React from 'react';
import { useForm } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import emailjs from 'emailjs-com'; // Import EmailJS
import './contact_form.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortDown } from '@fortawesome/free-solid-svg-icons';
import Successful_modal from '../../Common_Component/modals/succcessful-modal/Successful_modal';
import { contactusForm, InquireForm } from '../../../features/contact_us/Slice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../../../utils/ApiInstance';

const Contact_form = () => {
  const [modalShow, setModalShow] = React.useState(false);

  const navigate = useNavigate()
  // React Hook Form
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm();


  const dispatch = useDispatch();
  const onSubmit = async (data) => {
    try {
      // console.log(data);
      data.api_key = process.env.REACT_APP_API_KEY
      const response = await axiosClient.post(
        'https://itsale.profcymacrm.com/api/website',
        data
      );
      console.log(response);

      // const formData = new FormData();
      // formData.append("f_name", data.firstName);
      // formData.append("l_name", data.lastName);
      // formData.append("email", data.email);
      // formData.append("mobile", data.contactNumber);
      // formData.append("industry", data.industry);
      // formData.append("message", data.message);
      // formData.append("api_key", process.env.REACT_APP_API_KEY);
      dispatch(InquireForm(data));

      // Show the success modal
      setModalShow(true);

      // Reset form fields
      reset();

      // Redirect after 1 second
      navigate("/thank-you");
      setTimeout(() => {
        setModalShow(false);
        navigate("/");
      }, 2000);
    } catch (error) {

    }



  };

  return (
    <>
      <section className="Contact_form">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            {/* First Name */}
            <div className="col-lg-6 mb-4">
              <div className="form-group">
                <Form.Label>First Name*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your First Name"
                  {...register("f_name", { required: "First name is required" })}
                />
                {errors.f_name && <span className="text-danger">{errors.f_name.message}</span>}
              </div>
            </div>

            {/* Last Name */}
            <div className="col-lg-6 mb-4">
              <div className="form-group">
                <Form.Label>Last Name*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your Last Name"
                  {...register("l_name", { required: "Last name is required" })}
                />
                {errors.l_name && <span className="text-danger">{errors.l_name.message}</span>}
              </div>
            </div>

            {/* Email */}
            <div className="col-lg-6 mb-4">
              <div className="form-group">
                <Form.Label>Email*</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your Email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: { value: /^\S+@\S+$/i, message: "Invalid email address" },
                  })}
                />
                {errors.email && <span className="text-danger">{errors.email.message}</span>}
              </div>
            </div>

            {/* Contact Number */}
            <div className="col-lg-6 mb-4">
              <div className="form-group">
                <Form.Label>Contact Number*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your Contact Number"
                  {...register("mobile", {
                    required: "Contact number is required",
                    pattern: { value: /^[0-9]{10}$/, message: "Enter a valid 10-digit number" },
                  })}
                />
                {errors.mobile && <span className="text-danger">{errors.mobile.message}</span>}
              </div>
            </div>

            {/* Industry */}
            <div className="col-lg-12 mb-4">
              <div className="form-group">
                <Form.Label>Service*</Form.Label>
                <Form.Select
                  {...register("industry", { required: "Industry is required" })}
                  aria-label="Default select example"
                >
                  <option value="">Select your Service</option>
                  <option value="Website Development">Website Development</option>
                  <option value="App Development">App Development</option>
                  <option value="Software Development">Software Development</option>
                </Form.Select>
                <button className="srcbtn" type="button">
                  <FontAwesomeIcon className="srchicn" icon={faSortDown} />
                </button>
                {errors.industry && <span className="text-danger">{errors.industry.message}</span>}
              </div>
            </div>

            {/* Message */}
            <div className="col-lg-12 mb-4">
              <div className="form-group">
                <Form.Label>How we can help you *</Form.Label>
                <Form.Control
                  style={{ height: "100px" }}
                  as="textarea"
                  placeholder="Type here..."
                  {...register("remark", { required: "Message is required" })}
                />
                {errors.remark && <span className="text-danger">{errors.remark.message}</span>}
              </div>
            </div>

            {/* Submit Button */}
            <div className="col-lg-12 mb-4">
              <div className="form-group">
                <button className="submit-btn" type="submit">
                  Submit
                </button>
              </div>

              {/* <div className='form-group'>
                <button className='submit-btn'type="button" onClick={() => setModalShow(true)}>Submit</button>
              </div> */}

            </div>
          </div>
        </Form>
      </section>

      {/* Success Modal */}
      <Successful_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        message="Message Sent Successfully"
      />
    </>
  );
};

export default Contact_form;
